import { FC } from "react";

interface ContactProps {
    name: string;
    title: string;
    email: string;
}


export const Contact: FC<ContactProps> = ({
    name,
    title,
    email,
}) => {
    return (
        <div className="bg-white rounded-2xl border border-solid border-slate-200 py-3 px-4">
            <div className="text-xl">
                {name}
            </div>
            <div>
                {title}
            </div>
            <a href={`mailto:${email}`} className="text-sky-500 text-lg hover:text-sky-400">
                {email}
            </a>
        </div>
    )
}